/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { createTheme } from '@mui/material/styles';
import { PROMETHEAN_BREAKPOINT_LG, PROMETHEAN_BREAKPOINT_MD, PROMETHEAN_BREAKPOINT_SM, PROMETHEAN_BREAKPOINT_XL } from '../styles/breakpoints/breakpoints';
export var gridTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: PROMETHEAN_BREAKPOINT_SM,
      md: PROMETHEAN_BREAKPOINT_MD,
      lg: PROMETHEAN_BREAKPOINT_LG,
      xl: PROMETHEAN_BREAKPOINT_XL
    }
  }
});